// extracted by mini-css-extract-plugin
export default {"Opps":"opps_Opps__Q-Qtk","OppsButton":"opps_OppsButton__x7s-+","text":"opps_text__wGarJ"};